<template>
  <div class="szw-col szw-h-full szw-justify-center szw-items-center szw-uppercase" :class="classes">
    <div class="szw-flex szw-justify-center szw-items-center">
      <div class="szw-mx-2 szw-text-sm szw-font-semibold">
        {{ props.cards.yellow }}
      </div>
      <div class="szw-flex">
        <div class="szw-card-yellow" />
        <div class="szw-card-red" />
      </div>
      <div class="szw-mx-2 szw-text-sm szw-font-semibold">
        {{ props.cards.red }}
      </div>
    </div>
    <div class="szw-text-center szw-max-w-16 szw-mt-2 szw-text-xs szw-font-normal szw-leading-4">
      {{ loc('statistics_cards', langId) }}
    </div>
  </div>
</template>

<script setup>
import { loc } from '@/__core__/localization/localization'
import { inject } from 'vue'

const props = defineProps({
  cards: {
    type: Object,
    default: () => ({ yellow: 0, red: 0, label: 'Cards given' }),
    required: true
  },
  classes: {
    type: String,
    default: () => ''
  }
})

const langId = inject('langId')
</script>
